import React from 'react';

// Types
import { QuestionVisibilityType } from 'Shared/types/ReviewFormTemplate.type';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { WpCollapsible } from 'Wpds/components/collapsible';

type Props = {
  question;
  isOpen: boolean;
  handleMoveNext: () => void;
  handleMoveBack?: () => void;
  answers;
  handleSetAnswers: Function;
};

const OnlyForSelfReviewQuestion = ({
  question,
  isOpen,
  handleMoveNext,
  handleMoveBack,
}: // isSummaryQuestion,
Props) => {
  const header = ReviewFormTemplatesHelpers.getQuestionHeader(question);
  const questionVisibility = ReviewFormTemplatesHelpers.getQuestionVisibility(question);

  const baseClassName = 'OnlyForSelfReviewQuestion';
  return (
    <WpContainer className={baseClassName}>
      <WpContainerHeader>
        <p>{header}</p>
      </WpContainerHeader>

      <WpCollapsible open={isOpen}>
        <>
          <WpContainerBody>
            {questionVisibility === QuestionVisibilityType.SELF_REVIEW && (
              <p>This question is only for the reviewee. Please skip this question by clicking &apos;Next&apos;.</p>
            )}
            {questionVisibility === QuestionVisibilityType.NON_SELF_REVIEW && (
              <p>This question is not for the reviewee. Please skip this question by clicking &apos;Next&apos;.</p>
            )}
          </WpContainerBody>
          <WpContainerFooter justifyContent="flexEnd">
            <WpButtonGroup>
              {handleMoveBack && (
                <WpButton onClick={handleMoveBack} variant="tertiary">
                  Back
                </WpButton>
              )}
              {handleMoveNext && <WpButton onClick={handleMoveNext}>Next</WpButton>}
            </WpButtonGroup>
          </WpContainerFooter>
        </>
      </WpCollapsible>
    </WpContainer>
  );
};

export default OnlyForSelfReviewQuestion;
